import React from "react";
import PropTypes from "prop-types";

import getPrintColors from "./printDocumentStyles";
import PrintDocumentHeader from "./printDocumentHeader";
import PrintDocumentInfo from "./printDocumentInfo";
import PrintDocumentBody from "./printDocumentBody";
import PrintDocumentTotal from "./printDocumentTotal";
import PrintDocumentSignature from "./printDocumentSignature";
import PrintDocumentDiscountsList from "./printDocumentDiscountsList";
// import {PrintDocumentContext} from "./printDocumentContext";
import {TRANSLATES} from "../../../translatesProvider";
import PrintDocumentDisclaimer from "./printDocumentDisclaimer";
import PrintDocumentAsCentralText from "./printDocumentAsCentralText";
import {getShowPrice} from "../../../misc/priceFunctions";
import {IS_AS_WORK_ORDER} from "../../../config";
import {shouldUseMultipleWorkSheets} from "../../priceWorksheet/discountFunctions";


const PrintDocument = (props) => {
  const {fabricatorData, userInfo, quotes, cartItems, priceWorksheetState, jobId, assignQuotePopupCustomer,
    employeeSelected, locale, filterGroups, activeTheme, printLogo, wizardState, sqftSlabState, cartItemsThumbnails,
    printState, onRender, isContractSign, paymentState} = props;

  const {Document, Page, Text} = window.ReactPdfRenderer;

  const styles = getPrintColors(activeTheme);
  const showPrice = getShowPrice(fabricatorData, true);
  const showDiscounts = priceWorksheetState.discountSections.length;
  const hasMultipleWorkSheets = showDiscounts && shouldUseMultipleWorkSheets(priceWorksheetState.workSheetsCount);

  return (
    <Document onRender={onRender}>
      <Page style={fabricatorData.isAmericanStandard ? styles.pageAS : styles.page}
            object-fit="fill"
            size="A4">
        <PrintDocumentHeader fabricatorData={fabricatorData}
                             jobId={jobId}
                             styles={styles}
                             printLogo={printLogo}
                             messages={TRANSLATES}/>
        <PrintDocumentInfo userInfo={userInfo}
                           fabricatorData={fabricatorData}
                           assignQuotePopupCustomer={assignQuotePopupCustomer}
                           paymentState={paymentState}
                           employeeSelected={employeeSelected}
                           messages={TRANSLATES}
                           styles={styles}/>
        {fabricatorData.isAmericanStandard && !IS_AS_WORK_ORDER ? <PrintDocumentAsCentralText styles={styles}/> : null}
        <PrintDocumentBody quotes={quotes}
                           cartItemsThumbnails={cartItemsThumbnails}
                           cartItems={cartItems}
                           locale={locale}
                           fabricatorData={fabricatorData}
                           filterGroups={filterGroups}
                           wizardState={wizardState}
                           sqftSlabState={sqftSlabState}
                           messages={TRANSLATES}
                           hasMultipleWorkSheets={hasMultipleWorkSheets}
                           priceWorksheetState={priceWorksheetState}
                           styles={styles}/>
        {showDiscounts && !hasMultipleWorkSheets ? (
          <PrintDocumentDiscountsList priceWorksheetState={priceWorksheetState}
                                      hasMultipleWorkSheets={hasMultipleWorkSheets}
                                      fabricatorSettings={fabricatorData.settings}
                                      messages={TRANSLATES}
                                      wizardState={wizardState}
                                      styles={styles}/>
        ) : null}
        {showPrice ? (
          <PrintDocumentTotal priceWorksheetState={priceWorksheetState}
                              hasMultipleWorkSheets={hasMultipleWorkSheets}
                              wizardState={wizardState}
                              quotes={quotes}
                              fabricatorData={fabricatorData}
                              locale={locale}
                              cartItems={cartItems}
                              messages={TRANSLATES}
                              printState={printState}
                              styles={styles}/>
        ) : null}
        <PrintDocumentDisclaimer withTotal={false}
                                 showPrice={showPrice}
                                 styles={styles}
                                 locale={locale}
                                 messages={TRANSLATES}
                                 fabricatorData={fabricatorData}/>
        <PrintDocumentSignature styles={styles}
                                userInfo={userInfo}
                                locale={locale}
                                fabricatorData={fabricatorData}
                                assignQuotePopupCustomer={assignQuotePopupCustomer}
                                isContractSign={isContractSign}
                                messages={TRANSLATES}
                                receiptSignature={printState.receiptSignature}/>
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />
      </Page>
    </Document>
  )
};

PrintDocument.propTypes = {
  quotes: PropTypes.array.isRequired,
  cartItems: PropTypes.array.isRequired,
  priceWorksheetState: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  jobId: PropTypes.number,
  assignQuotePopupCustomer: PropTypes.object,
  employeeSelected: PropTypes.object,
  locale: PropTypes.string.isRequired,
  activeTheme: PropTypes.string,
  printLogo: PropTypes.string,
  wizardState: PropTypes.object.isRequired,
  isContractSign: PropTypes.bool,
  printState: PropTypes.object,
};

export default PrintDocument
